import $ from 'jquery';
import {Swiper, Autoplay, Pagination, Navigation} from 'swiper/js/swiper.esm.js';
Swiper.use([Autoplay, Pagination, Navigation]);

const heroSwiper = new Swiper('.swiper-hero', {
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},
	navigation: {
		prevEl: '.swiper-button-prev',
		nextEl: '.swiper-button-next',
	},
});
